import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenAdidasLongSleeve = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[7].productName}
				color={product.allGear[7].color}
				size={product.allGear[7].sizes}
				price={product.allGear[7].price}
				img={product.allGear[7].img}
				miniImg1={product.allGear[7].miniImg1}
				miniImg2={product.allGear[7].miniImg2}
				miniImg3={product.allGear[7].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenAdidasLongSleeve;
